import { useMutation, useQuery } from "react-query";
import { get, put } from "../../common/api/apiShared";
import { WatchPriceDto } from "./WatchPrices.types";

export function useWatchPrices() {
    const { isLoading, data, refetch } = useQuery("collection-of-watchPrices", () => get<Array<WatchPriceDto>>(`/api/watchprices`));

    function updatePriceApi(watchPrice: { price: string | null; id: string }) {
        return put<{}>(`/api/watchprices/${watchPrice.id}/`, {
            price: watchPrice.price ? Number(watchPrice.price) : null,
        });
    }

    const saveNoteMutation = useMutation(updatePriceApi);
    const updatePrice = (watchPrice: { price: string | null; id: string }) => {
        saveNoteMutation.mutateAsync(watchPrice, {
            onSuccess: (resp: any) => {
                refetch();
            },
        });
    };

    return {
        isLoading,
        data,
        refetch,
        updatePrice,
    };
}
